import { Link } from 'react-router-dom';
import { featuredCategories } from '@/mocks/home';

const colorMap: Record<string, { bg: string; iconBg: string; hoverBg: string; text: string }> = {
  primary: {
    bg: 'hover:bg-primary-50',
    iconBg: 'bg-primary-100',
    hoverBg: 'group-hover:bg-primary-500',
    text: 'text-primary-600 group-hover:text-white',
  },
  accent: {
    bg: 'hover:bg-accent-50',
    iconBg: 'bg-accent-100',
    hoverBg: 'group-hover:bg-accent-500',
    text: 'text-accent-600 group-hover:text-white',
  },
  secondary: {
    bg: 'hover:bg-secondary-50',
    iconBg: 'bg-secondary-100',
    hoverBg: 'group-hover:bg-secondary-500',
    text: 'text-secondary-600 group-hover:text-white',
  },
};

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block px-4 py-1.5 border border-accent-300 text-accent-600 text-sm font-medium rounded-full mb-4">
            内容分类
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            海量视频 · 一网打尽
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[500px] mx-auto">
            涵盖电影、剧集、综艺、动漫等多个品类，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredCategories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.id}
                to={cat.link}
                className={`group flex flex-col p-6 md:p-7 rounded-2xl bg-background-50 transition-all duration-300 ${colors.bg} cursor-pointer`}
              >
                <div className={`w-12 h-12 ${colors.iconBg} rounded-xl flex items-center justify-center mb-5 transition-all duration-300 ${colors.hoverBg}`}>
                  <i className={`${cat.icon} text-xl ${colors.text} transition-colors duration-300`}></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
                  {cat.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4 flex-1">
                  {cat.description}
                </p>
                <span className={`inline-flex items-center gap-1 text-sm font-medium ${colors.text.split(' ')[0]} transition-colors`}>
                  浏览内容
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}